// extracted by mini-css-extract-plugin
export var column = "site-map-columns-module--column--43614";
export var redirectLink = "site-map-columns-module--redirectLink--a2bab";
export var title = "site-map-columns-module--title--68157";